import Excel from "exceljs";
import { saveAs } from "file-saver";
import _ from "lodash";
import { formatDate } from "./formatter";
import { formatMoney } from "./formatter";

const workbook = new Excel.Workbook();
const workSheetName = "Worksheet-1";

/**
 * Funcion para exportar archivo excel desde una variable array
 * @param {String} fileName Nombre archivo a exportar sin incluir .xlsx
 * @param {{}} columns Columnas en formato { header: "Titulo", key: "key object" }
 * @param {[{}]} data Informacion en array de objects
 */

export default async function saveExcel(fileName, columns, data) {
    try {
        // creating one worksheet in workbook
        const worksheet = workbook.addWorksheet(workSheetName);

        // add worksheet columns
        // each columns contains header and its mapping key from data
        worksheet.columns = columns;

        // updated the font for first row.
        worksheet.getRow(1).font = { bold: true };

        // loop through all of the columns and set the alignment with width.
        worksheet.columns.forEach((column) => {
            // column.width = column.header.length + 15;
            column.alignment = { horizontal: "left" };
        });

        // loop through data and add each one to worksheet

        let isKeyAccesorNeed =
            _(columns)
                .map("key")
                .filter((k) => k.includes("."))
                .value().length > 0 || _(columns).map("type").compact().value().length > 0;

        data.forEach((singleData) => {
            if (isKeyAccesorNeed) {
                let customData = {};
                _.each(columns, (c) => {
                    if (c.type && c.format) {
                        if (c.type == "date") {
                            customData[c.key] = formatDate(_.get(singleData, c.key), c.format);
                        } else if (c.type == "number") {
                            customData[c.key] = formatMoney(_.get(singleData, c.key), c.format);
                        }
                    } else {
                        customData[c.key] = _.get(singleData, c.key);
                    }
                });
                worksheet.addRow(customData);
            } else {
                worksheet.addRow(singleData);
            }
        });

        // loop through all of the rows and set the outline style.
        worksheet.eachRow({ includeEmpty: false }, (row) => {
            // store each cell to currentCell
            const currentCell = row._cells;

            // loop through currentCell to apply border only for the non-empty cell of excel
            currentCell.forEach((singleCell) => {
                // store the cell address i.e. A1, A2, A3, B1, B2, B3, ...
                const cellAddress = singleCell._address;

                // apply border
                worksheet.getCell(cellAddress).border = {
                    top: { style: "thin" },
                    left: { style: "thin" },
                    bottom: { style: "thin" },
                    right: { style: "thin" },
                };
            });
        });

        //AUTO WIDTH
        worksheet.columns.forEach((column) => {
            let maxColumnLength = 0,
                minimalWidth = 7;
            column.eachCell({ includeEmpty: true }, (cell) => {
                maxColumnLength = Math.max(maxColumnLength, minimalWidth, cell.value ? cell.value.toString().length : 0);
            });
            column.width = maxColumnLength + 2;
        });

        // write the content using writeBuffer
        const buf = await workbook.xlsx.writeBuffer();

        // download the processed file
        saveAs(new Blob([buf]), `${fileName}.xlsx`);
    } catch (error) {
        console.error("<<<ERRROR>>>", error);
        console.error("Something Went Wrong", error.message);
    } finally {
        // removing worksheet's instance to create new one
        workbook.removeWorksheet(workSheetName);
    }
}
